// extracted by mini-css-extract-plugin
export var listaEmpresas = "styles-module--listaEmpresas--WA3o3";
export var link = "styles-module--link--1LcOK";
export var logo = "styles-module--logo--X_pvA";
export var img = "styles-module--img--2EtDP";